import { FARM_CONTEXT_STORAGE_KEY } from '../constants/farmContext';
import { apiUrl } from './apiUrl';

export async function authFetch(
  url,
  options = {},
  { token, onUnauthorized, farmContextId, omitFarmContext } = {}
) {
  const headers = new Headers(options.headers || {});
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  if (!omitFarmContext) {
    let farmHeader = farmContextId;
    if (!farmHeader && typeof window !== 'undefined') {
      try {
        farmHeader = window.localStorage?.getItem(FARM_CONTEXT_STORAGE_KEY) ||
          window.sessionStorage?.getItem(FARM_CONTEXT_STORAGE_KEY);
      } catch {
        farmHeader = null;
      }
    }
    if (farmHeader && !headers.has('X-Farm-Context')) {
      headers.set('X-Farm-Context', String(farmHeader));
    }
  }
  const response = await fetch(apiUrl(url), { credentials: 'same-origin', ...options, headers });
  if (response.status === 401 && onUnauthorized) {
    onUnauthorized();
  }
  return response;
}
